import { PostBase, PostStatusCode } from '@/features/posts/types/post-base';

/**
 * Determine whether is in a published state or not.
 */
export const isPostPublished = (post: PostBase) => {
  return post.status.code === PostStatusCode.Published;
};
